import { render, staticRenderFns } from "./ProductEditTabAccount.vue?vue&type=template&id=6820462d&"
import script from "./ProductEditTabAccount.vue?vue&type=script&lang=js&"
export * from "./ProductEditTabAccount.vue?vue&type=script&lang=js&"
import style0 from "./ProductEditTabAccount.vue?vue&type=style&index=0&id=6820462d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports